// *** novacontacliente.jsx ***
// *** autor: W de Paula / MVinfo ***
// *** data: 05/05/24 | 09h59 ***
// *** data: 22/07/24 | 14h45 | implementação do token JWT ***
// *** data: 13/09/24 | 17h36 | modificação de "function NovaConta" para "NovaContaCliente" para não confundir com o prestador ***
// *** data: 29/10/24 | 11h31 | acrescentado campo de "confirmação de email"




import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AgendexLogo from '../../Assets/agendex/iconLogoAgendex.png';
import AgendexCliente from '../../Assets/agendex/logoagendexcliente.png';
import apiaxios from '../../Services/apiaxios';
import InputMask from 'react-input-mask';
import Swal from 'sweetalert2';
import { encryptPass } from '../../Services/cryptosenha';

import "./novaconta.css";

function NovaContaCliente() {
    var ano = new Date().getFullYear();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        nome: '',
        email: '',
        confirmaEmail: '', // acrescentada 24/10/24w17h41
        telefone: '',
        uf: '',
        cidade: '',
        senha: '',
        confirmaSenha: '',
        politicaPrivacidade: false,
        termosUso: false,
    });

    const [ufs, setUfs] = useState([]);
    const [cidades, setCidades] = useState([]);
    const [isFormValid, setIsFormValid] = useState(false);

    useEffect(() => {
        async function fetchUfs() {
            try {
                const response = await fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados');
                const data = await response.json();
                const sortedData = data.sort((a, b) => a.nome.localeCompare(b.nome));
                setUfs(sortedData);
            } catch (error) {
                console.error('Erro ao buscar UFs:', error);
            }
        }
        fetchUfs();
    }, []);

    useEffect(() => {
        async function fetchCidades() {
            if (formData.uf) {
                try {
                    const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${formData.uf}/municipios`);
                    const data = await response.json();
                    const sortedData = data.sort((a, b) => a.nome.localeCompare(b.nome));
                    setCidades(sortedData);
                } catch (error) {
                    console.error('Erro ao buscar cidades:', error);
                }
            } else {
                setCidades([]);
            }
        }
        fetchCidades();
    }, [formData.uf]);

    useEffect(() => {
        validateForm();
    }, [formData]);

    const validateForm = () => {
        const nomeValido = formData.nome.length >= 5 && /^[a-zA-Z\s]+$/.test(formData.nome);
        const emailValido = /\S+@\S+\.\S+/.test(formData.email);
        const confirmaEmailValido = /\S+@\S+\.\S+/.test(formData.confirmaEmail);
        const telefoneValido = /^\(\d{2}\)\d{5}-\d{4}$/.test(formData.telefone);
        const ufValido = formData.uf.length > 0;
        const cidadeValido = formData.cidade.length > 0;
        const emailsIguais = formData.email === formData.confirmaEmail;
        const senhaValida = formData.senha.length >= 3 && formData.senha.length <= 50;
        const senhasIguais = formData.senha === formData.confirmaSenha;
        const checkboxesMarcados = formData.politicaPrivacidade && formData.termosUso;

        setIsFormValid(nomeValido && emailValido && confirmaEmailValido && telefoneValido && ufValido && cidadeValido && emailsIguais &&senhaValida && senhasIguais && checkboxesMarcados);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'nome') {
            if (/^[a-zA-Z\s]*$/.test(value)) {
                setFormData({
                    ...formData,
                    [name]: value
                });
            }
        } else {
            setFormData({
                ...formData,
                [name]: type === 'checkbox' ? checked : value
            });
        }
    };

    const handlePoliticaPrivacidade = () => {
        Swal.fire({
            title: 'Política de Privacidade',
            html: `<iframe src="https://www.freeprivacypolicy.com/live/7537ad5c-e32a-4dda-b746-a83891d57061" width="100%" height="400px"></iframe>`,
            width: '600px',
            showCloseButton: true,
            focusConfirm: false,
        });
    };

    const handleTermosUso = () => {
        Swal.fire({
            title: 'Termos de Uso',
            // html: `<div style="text-align: left; max-height: 400px; overflow-y: auto;">${termosDeUso}</div>`,
            html: `<iframe src="https://www.freeprivacypolicy.com/live/7ade3469-ff51-4c9a-aff8-88d9211cc0c5" width="100%" height="400px"></iframe>`,
            width: '600px',
            showCloseButton: true,
            focusConfirm: false,
        });
    };

    const criarConta = async () => {
        if (!isFormValid) return;

        const { nome, email, telefone, uf, cidade, senha } = formData;

        const novaContaData = {
            email,
            nome,
            senha: encryptPass(senha),
            fone: telefone,
            cidade,
            uf,
            pais: 'BRASIL', // ou você pode adicionar isso como outro campo no formulário
            nt_id: 0,
            cod_notificacao: 71 // novo cliente fez cadastro básico
        };

        try {
            const response = await apiaxios.post('/usuario/NovaContaWeb', novaContaData);
            if (response.status === 201) {
                Swal.fire({
                    title: 'Sucesso!',
                    text: 'Conta criada com sucesso! Por favor, faça o login.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(() => {
                    navigate('/app/login/cliente');
                });
            } else {
                const errorMessage = response && response.data && response.data.retorno
                    ? response.data.retorno
                    : 'Erro ao criar conta.';
                Swal.fire('Erro', errorMessage, 'error');
            }
        } catch (error) {
            const errorMessage = error.response && error.response.data && error.response.data.retorno
                ? error.response.data.retorno
                : 'Erro ao criar conta.';
            Swal.fire('Erro', errorMessage, 'error');
        }
    };

    // const termosDeUso = `
    //     <h2><span style="color: rgb(68, 68, 68);">1. Termos</span></h2><p><span style="color: rgb(68, 68, 68);">Ao acessar ao site <a href="https://www.agendex.net.br">Agendex | Minha Agenda | All-in-one</a>, concorda em cumprir estes termos de serviço, todas as leis e regulamentos aplicáveis ​​e concorda que é responsável pelo cumprimento de todas as leis locais aplicáveis. Se você não concordar com algum desses termos, está proibido de usar ou acessar este site. Os materiais contidos neste site são protegidos pelas leis de direitos autorais e marcas comerciais aplicáveis.</span></p><h2><span style="color: rgb(68, 68, 68);">2. Uso de Licença</span></h2><p><span style="color: rgb(68, 68, 68);">É concedida permissão para baixar temporariamente uma cópia dos materiais (informações ou software) no site Agendex | Minha Agenda | All-in-one , apenas para visualização transitória pessoal e não comercial. Esta é a concessão de uma licença, não uma transferência de título e, sob esta licença, você não pode:&nbsp;</span></p><ol><li><span style="color: rgb(68, 68, 68);">modificar ou copiar os materiais;&nbsp;</span></li><li><span style="color: rgb(68, 68, 68);">usar os materiais para qualquer finalidade comercial ou para exibição pública (comercial ou não comercial);&nbsp;</span></li><li><span style="color: rgb(68, 68, 68);">tentar descompilar ou fazer engenharia reversa de qualquer software contido no site Agendex | Minha Agenda | All-in-one;&nbsp;</span></li><li><span style="color: rgb(68, 68, 68);">remover quaisquer direitos autorais ou outras notações de propriedade dos materiais; ou&nbsp;</span></li><li><span style="color: rgb(68, 68, 68);">transferir os materiais para outra pessoa ou 'espelhe' os materiais em qualquer outro servidor.</span></li></ol><p><span style="color: rgb(68, 68, 68);">Esta licença será automaticamente rescindida se você violar alguma dessas restrições e poderá ser rescindida por Agendex | Minha Agenda | All-in-one a qualquer momento. Ao encerrar a visualização desses materiais ou após o término desta licença, você deve apagar todos os materiais baixados em sua posse, seja em formato eletrónico ou impresso.</span></p><h2><span style="color: rgb(68, 68, 68);">3. Isenção de responsabilidade</span></h2><ol><li><span style="color: rgb(68, 68, 68);">Os materiais no site da Agendex | Minha Agenda | All-in-one são fornecidos 'como estão'. Agendex | Minha Agenda | All-in-one não oferece garantias, expressas ou implícitas, e, por este meio, isenta e nega todas as outras garantias, incluindo, sem limitação, garantias implícitas ou condições de comercialização, adequação a um fim específico ou não violação de propriedade intelectual ou outra violação de direitos.</span></li><li><span style="color: rgb(68, 68, 68);">Além disso, o Agendex | Minha Agenda | All-in-one não garante ou faz qualquer representação relativa à precisão, aos resultados prováveis ​​ou à confiabilidade do uso dos materiais em seu site ou de outra forma relacionado a esses materiais ou em sites vinculados a este site.</span></li></ol><h2><span style="color: rgb(68, 68, 68);">4. Limitações</span></h2><p><span style="color: rgb(68, 68, 68);">Em nenhum caso o Agendex | Minha Agenda | All-in-one ou seus fornecedores serão responsáveis ​​por quaisquer danos (incluindo, sem limitação, danos por perda de dados ou lucro ou devido a interrupção dos negócios) decorrentes do uso ou da incapacidade de usar os materiais em Agendex | Minha Agenda | All-in-one, mesmo que Agendex | Minha Agenda | All-in-one ou um representante autorizado da Agendex | Minha Agenda | All-in-one tenha sido notificado oralmente ou por escrito da possibilidade de tais danos. Como algumas jurisdições não permitem limitações em garantias implícitas, ou limitações de responsabilidade por danos conseqüentes ou incidentais, essas limitações podem não se aplicar a você.</span></p><h2><span style="color: rgb(68, 68, 68);">5. Precisão dos materiais</span></h2><p><span style="color: rgb(68, 68, 68);">Os materiais exibidos no site da Agendex | Minha Agenda | All-in-one podem incluir erros técnicos, tipográficos ou fotográficos. Agendex | Minha Agenda | All-in-one não garante que qualquer material em seu site seja preciso, completo ou atual. Agendex | Minha Agenda | All-in-one pode fazer alterações nos materiais contidos em seu site a qualquer momento, sem aviso prévio. No entanto, Agendex | Minha Agenda | All-in-one não se compromete a atualizar os materiais.</span></p><h2><span style="color: rgb(68, 68, 68);">6. Links</span></h2><p><span style="color: rgb(68, 68, 68);">O Agendex | Minha Agenda | All-in-one não analisou todos os sites vinculados ao seu site e não é responsável pelo conteúdo de nenhum site vinculado. A inclusão de qualquer link não implica endosso por Agendex | Minha Agenda | All-in-one do site. O uso de qualquer site vinculado é por conta e risco do usuário.</span></p><p><br></p><h3><span style="color: rgb(68, 68, 68);">Modificações</span></h3><p><span style="color: rgb(68, 68, 68);">O Agendex | Minha Agenda | All-in-one pode revisar estes termos de serviço do site a qualquer momento, sem aviso prévio. Ao usar este site, você concorda em ficar vinculado à versão atual desses termos de serviço.</span></p><h3><span style="color: rgb(68, 68, 68);">Lei aplicável</span></h3><p><span style="color: rgb(68, 68, 68);">Estes termos e condições são regidos e interpretados de acordo com as leis do Agendex | Minha Agenda | All-in-one e você se submete irrevogavelmente à jurisdição exclusiva dos tribunais naquele estado ou localidade.</span></p>
    //     <!-- Adicione o texto completo dos Termos de Uso -->
    // `;

    return (
        <section id="novacontacliente">
            <div className="container login-container">
                <div className="row">
                    <div className="col-md-6 login-form-1">
                        <img className="login-cliente-img" src={AgendexCliente} alt='Nova Conta Cliente' />
                        <h3>Criar Conta Cliente (Consumidor)</h3>

                        <div className="form-group mb-3">
                            <input type="text" className="form-control" id="nomecliente" name="nome" value={formData.nome} onChange={handleChange} placeholder="Digite seu Nome (*)" />
                        </div>
                        <div className="form-group mb-3">
                            <input type="text" className="form-control" id="emailcliente" name="email" value={formData.email.toLowerCase()} onChange={handleChange} placeholder="Digite seu Email preferencial (*)" />
                        </div>
                        <div className="form-group mb-3">
                            <input type="text" className="form-control" id="confirmaemailcliente" name="confirmaEmail" value={formData.confirmaEmail.toLowerCase()} onChange={handleChange} placeholder="Repita seu Email (*)" />
                        </div>
                        <div className="form-group mb-3">
                            <InputMask
                                mask="(99)99999-9999"
                                value={formData.telefone}
                                onChange={handleChange}
                            >
                                {() => <input type="text" className="form-control" id="fonecliente" name="telefone" placeholder="Telefone com DDD (WhatsApp preferencial)" />}
                            </InputMask>
                        </div>
                        <div className="form-group mb-3">
                            <select className="form-control" id="ufcliente" name="uf" value={formData.uf} onChange={handleChange}>
                                <option value="">Selecione seu Estado (*)</option>
                                {ufs.map((uf) => (
                                    <option key={uf.sigla} value={uf.sigla}>{uf.nome}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group mb-3">
                            <select className="form-control" id="cidadecliente" name="cidade" value={formData.cidade} onChange={handleChange} disabled={!formData.uf}>
                                <option value="">Selecione sua Cidade (*)</option>
                                {cidades.map((cidade) => (
                                    <option key={cidade.id} value={cidade.nome}>{cidade.nome}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group mb-3">
                            <input type="password" className="form-control" id="senhacliente" name="senha" value={formData.senha} onChange={handleChange} placeholder="Digite uma senha (*)" />
                        </div>
                        <div className="form-group mb-3">
                            <input type="password" className="form-control" id="confirmesenhacliente" name="confirmaSenha" value={formData.confirmaSenha} onChange={handleChange} placeholder="Confirme a senha (*)" />
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="politicaPrivacidade" name="politicaPrivacidade" checked={formData.politicaPrivacidade} onChange={handleChange} />
                            <label className="form-check-label" htmlFor="politicaPrivacidade">
                                <button type="button" className="btn-link" onClick={handlePoliticaPrivacidade}>Aceito a "Política de Privacidade"</button>
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="termosUso" name="termosUso" checked={formData.termosUso} onChange={handleChange} />
                            <label className="form-check-label" htmlFor="termosUso">
                                <button type="button" className="btn-link" onClick={handleTermosUso}>Aceito os "Termos de Uso"</button>
                            </label>
                        </div>
                        <div className="form-group mt-4">
                            <button
                                type="button"
                                className={`btnSubmit ${isFormValid ? 'btn btn-primary' : 'btn btn-secondary disabled'}`}
                                disabled={!isFormValid}
                                onClick={criarConta}
                            >
                                Cliente Criar Conta
                            </button>
                        </div>
                    </div>
                    <div className="col-md-6 login-form-2">
                        <img src={AgendexLogo} alt="Agendex Logo" />
                    </div>
                </div>
                <div className="textoRodape" >
                    <Link to="/app/login">Já tenho conta. Toque para fazer login.</Link>
                    <p > Desenvolvido por MVinfo Sistemas | WMX Group 2021 - {ano}</p>
                </div>
            </div>
        </section>
    );
}

export default NovaContaCliente;
